import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M2.893 17.299c-1.249 1.237-1.526 4.15-1.584 5.122a.277.277 0 00.08.231.347.347 0 00.232.092c.983-.069 3.885-.346 5.133-1.595a2.647 2.647 0 000-3.862 2.913 2.913 0 00-1.977-.844 2.633 2.633 0 00-1.884.856zM15.703 16.05l-.312-.902c4.359-2.705 8.093-6.093 7.157-13.296a.624.624 0 00-.578-.543C14.732.765 11.564 4.639 9.044 9.125l-.925-.278a3.353 3.353 0 00-3.25.96l-1.49 1.491a1.307 1.307 0 00-.313 1.272c.06.206.171.393.324.543.18.173.411.282.659.313l3.122.554 3.376 3.215.693 3.064c.053.25.178.478.359.659.153.15.345.253.555.3a1.318 1.318 0 001.26-.37l1.526-1.457a3.353 3.353 0 00.763-3.34zm-.289-7.272a1.885 1.885 0 112.671-.07 1.896 1.896 0 01-2.67.07z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
